import { useCallback, useEffect, useRef, useState } from 'react'
import { Button, DatePicker, Form } from 'antd'
import dayjs from 'dayjs';
import { GetHistoricalBunker } from '../../../Api/getData';
import { useSearchParams } from 'react-router-dom';
import { HiCalendar, HiSearch } from 'react-icons/hi';

const { RangePicker } = DatePicker;

const StartRange = () => dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss');
const EndRange = () => dayjs().format('YYYY-MM-DD HH:mm:ss');

const FilterBucker = ({ onData }) => {
    const [searchParams] = useSearchParams();
    const KodeCabang = searchParams.get("KodeCabang") || "SGM";
    const ShipCode = searchParams.get("ShipCode") || "G2008";

    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const onDataRef = useRef(onData);

    useEffect(() => {
        onDataRef.current = onData;
    }, [onData]);

    const fetchData = useCallback(async (startDate, endDate) => {
        setIsLoading(true);
        try {
            const [response] = await GetHistoricalBunker({
                AccountId: KodeCabang,
                ObjectCode: ShipCode,
                StartDate: startDate,
                EndDate: endDate,
            });
            onDataRef.current(response);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }, [KodeCabang, ShipCode]);

    useEffect(() => {
        fetchData(StartRange(), EndRange());
    }, [fetchData]);

    const onSubmit = async (values) => {
        const { RangeDate } = values;
        const startDateRange = RangeDate ? dayjs(RangeDate[0]).format('YYYY-MM-DD HH:mm:ss') : StartRange();
        const endDateRange = RangeDate ? dayjs(RangeDate[1]).format('YYYY-MM-DD HH:mm:ss') : EndRange();
        fetchData(startDateRange, endDateRange);
    };

    return (
        <Form
                layout="vertical"
            onFinish={onSubmit}
            form={form}
            initialValues={{
                RangeDate: [dayjs(StartRange()), dayjs(EndRange())]
            }}
        >
            <div className="analytics-date-filter">
                <div className="flex-1">
                    <label className="flex items-center gap-1.5 text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                        <HiCalendar className="w-3.5 h-3.5" />
                        Date Range
                    </label>
                    <Form.Item name="RangeDate" className="mb-0">
                        <RangePicker
                            popupClassName="analytics-date-popup"
                            showTime={{ format: 'HH:mm:ss' }}
                            format="YYYY-MM-DD HH:mm:ss"
                            className="w-full"
                        />
                    </Form.Item>
                </div>
                <Button
                    htmlType="submit"
                    type="primary"
                    loading={isLoading}
                    icon={<HiSearch className="w-4 h-4" />}
                    className="analytics-apply"
                >
                    Apply
                </Button>
            </div>
        </Form>
    );
};

export default FilterBucker;
